<h2 mat-dialog-title align="center">Reset Password</h2>
<div mat-dialog-content style="overflow-y: hidden;">
    <form id="form" [formGroup]="form" class="creation-form" autocomplete="off">
        <div class="grid gap-16 col-2">
            <div>
                <label class="required">New Password</label>
                <mat-form-field appearance="outline">
                    <input matInput [type]="hideNewPassword ? 'password' : 'text'" formControlName="new_password"
                        autocomplete="off">
                    <button mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNewPassword">
                        <mat-icon class="text-primary">{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error *ngIf="form.get('new_password').errors?.minlength">
                        At Least 8 length
                    </mat-error>
                </mat-form-field>
            </div>
            <div>
                <label>Confirm Password</label>
                <mat-form-field appearance="outline">
                    <input matInput [type]="hideConfirmPassword ? 'password' : 'text'"
                        formControlName="confirm_password" autocomplete="off">
                    <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword">
                        <mat-icon class="text-primary">{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}
                        </mat-icon>
                    </button>
                    <mat-error *ngIf="form.get('confirm_password').errors?.nomatch">
                        Password must match
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" form="form" (click)="onSubmit()">Done</button>
</div>